import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { Paso2pagePage } from './paso2page.page';

const routes: Routes = [
  {
    path: '',
    component: Paso2pagePage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class Paso2pagePageRoutingModule {}
